import Solutions from 'Containers/Solutions';

export default Solutions;
